import React from 'react';
import CoopLogo from '../../Images/coopLogoDashboard.png';
import '../../CSS/foundation_css/_logo.css';
import '../../CSS/dashboard.css';
import { Link } from 'react-router-dom'

const DashboardLogo = (props) => {
  return (
    <div>
      <Link to="/DashboardLogin"><img src={CoopLogo} alt="" className="coop-logo-dashboard" /></Link>
    </div>
  )
}

export default DashboardLogo;
